import React from 'react';
import deburr from 'lodash/deburr';
import { B } from 'b_';

import InputComponents from './constants/input-components';
import isDevelopmentEnvironment from './isDevelopmentEnvironment';

export const isIterable = (object: any): boolean => !!object && typeof object[Symbol.iterator] === 'function';

export const bemHelper = () =>
  B({
    elementSeparator: '--',
    modSeparator: '__',
  });

export const isNull = (value: any): boolean => value === null;

export const unmask = (value: string | number): string => {
  const val = String(value);
  const isNegative = val[0] === '-';
  const unmasked = val.replace(/[^0-9.]/g, '');
  return isNegative ? `-${unmasked}` : unmasked;
};

export const strip = (str: string | number): string | number =>
  str ? deburr(str.toString().toLowerCase().trim()) : str;

export const deprecateProp = (substituteProp?: string) => (props: any, propName: string, componentName: string) => {
  const message = `'${propName}' prop in the '${componentName} Component' is deprecated! ${
    substituteProp ? `Use '${substituteProp}' prop instead!` : ''
  }`;
  if (isDevelopmentEnvironment() && (props[propName] || props[propName].length)) {
    console.warn(message);
  }
  return null;
};

export const isInputComponent = (child): boolean =>
  InputComponents.some(componentName => child && child.type && componentName === child.type.displayName);

export const injectInputComponents = (children, props) =>
  React.Children.map(children, child => {
    if (isInputComponent(child)) {
      return React.cloneElement(child, { ...props });
    }
    return child;
  });

export function injectChild(child, props) {
  if (child) {
    return React.cloneElement(child, { ...props });
  }
  return null;
}

export function injectChildren(props, newProps) {
  if (props.children && newProps) {
    return React.Children.map(props.children, child => React.cloneElement(child, { ...newProps }));
  }
  return null;
}

export function hasDocument() {
  return typeof document !== 'undefined';
}
